import { cloneDeep } from "lodash";

export default class CriteriaService {
    constructor(leftColumns = []) {
        this.leftColumns = leftColumns;
    }
    getEmptyRow(condition) { return { key: Math.random(), rhsType: 0, condition } }

    getCriteria = function (criteria, criteriaTree) {
        if (criteriaTree && criteriaTree.length > 0) {
            const generatedCriteriaRows = this.generateCriteriaRows(criteriaTree);
            return generatedCriteriaRows;
        }
    }

    getCriteriaForSave(criteriaArray) {
        let criteria = "",
            operation = "";

        criteriaArray.forEach((item, index) => {
          // if (item.type === "operator") {
          if (index == 0) {
            operation = "";
          } else {
            operation = item.condition;
          }
          // } else {
          var condition = this.getCriteriaRowValue(item);
          if (condition != "") {
            if (operation != "") criteria += " " + operation + "\r\n";
            criteria += condition;
          }
          operation = "";
          // }
        });

        return criteria;
    }


    getCriteriaRowValue({ lhs, operator: relation, rhs = "", rhsType: rhsOption, startDate, endDate, numberFrom, numberTo }) {
        const pattern = /.+\.star$/;
        const isMatch = pattern.test(lhs);
        if (rhs == "is starred" && isMatch) {
            if (relation == "string_equal") {
                relation = "string_not_empty"
            } else if (relation == "string_not_equal") {
                relation = "string_empty"
            }
        }
        var criteria = "";

        if (!lhs || !relation || ((rhsOption >= 1 && !rhs))) { // || (!rhs && (relation != "string_empty" && relation != "string_not_empty"))
            return "";
        }

        var formatForString = function (rhs, quotes) {
            quotes = quotes || false;
            return (!quotes) ? rhs : "'" + rhs + "'";
        };
        var formatForDateString = function (rhs, quotes) {
            let rhsDateValue = formatForString(rhs, quotes);
            if (rhsDateValue === "''") {
                rhsDateValue = "'0000-00-00'";
            }
            return rhsDateValue;
        };
        let isPercentageColumn = false;
        this.leftColumns.forEach(el => {
            if (el.alias_name == lhs || el.alias_path == lhs) {
                if (el.column_type_id == '22') {
                    isPercentageColumn = true;
                } else if (el.column_type_id == "10") {
                    let options = JSON.parse(el.options)
                    if (options && options[0].column_type == "percentage") {
                        isPercentageColumn = true
                    }
                }
            }
        })
        let percentageLookColumns = window.hasOwnProperty("percentageAliases") ? window["percentageAliases"] : []
        if (percentageLookColumns.includes(lhs)) {
            isPercentageColumn = true
        }
        if (isPercentageColumn && rhs) {
            rhs = String(rhs).replace("'", "").replace("'", "")
            let decimals = rhs.includes('.') ? rhs.split('.')[1].length : 0
            rhs = String((rhs / 100).toFixed(decimals + 2));
        }
        if (isPercentageColumn && relation == "number_between"){
            if(numberFrom){
                let decimals = String(numberFrom).includes(".") ? String(numberFrom).split(".")[1].length : 0 
                numberFrom = String((numberFrom/100).toFixed(decimals + 2)) 
            }
            if(numberTo){
                let decimals = String(numberTo).includes(".") ? String(numberTo).split(".")[1].length : 0
                numberTo = String((numberTo/100).toFixed(decimals + 2))
            }
        }
        criteria += lhs;
        switch (relation) {
            case "string_equal":
            case "string_not_equal":
                Array.isArray(rhs) && rhs.length > 1 && (criteria += `${relation === "string_not_equal" ? " not" : ""} in ( ` + rhs.map((val) => formatForString(val, (rhsOption < 1))) + " )");
                (!Array.isArray(rhs) || rhs.length <= 1) && (criteria += ` ${relation === "string_not_equal" ? "<>" : "="} ` + formatForString(Array.isArray(rhs) ? (rhs[0] ?? "") : rhs, (rhsOption < 1)))
                break;
            case "string_like":
                criteria += " LIKE " + ((rhsOption >= 1) ? "'%'+" + rhs + "+'%'" : formatForString("%" + rhs + "%", true));
                break;
            case "string_right_like":
                criteria += " LIKE " + ((rhsOption >= 1) ? rhs + "+'%'" : formatForString(rhs + "%", true));
                break;
            case "string_left_like":
                criteria += " LIKE " + ((rhsOption >= 1) ? "'%'+" + rhs : formatForString("%" + rhs, true));
                break;
            case "string_empty":
                criteria += " IS EMPTY";
                break;
            case "string_not_empty":
                criteria += " IS NOT EMPTY";
                break;
            case "string_not_like":
                criteria += " NOT LIKE " + ((rhsOption >= 1) ? "'%'+" + rhs + "+'%'" : formatForString("%" + rhs + "%", true));
                break;
            case "number_ge":
                criteria += " >= " + formatForString(rhs, rhs === "");
                break;
            case "number_le":
                criteria += " <= " + formatForString(rhs, rhs === "");
                break;
            case "number_ne":
                criteria += " <> " + formatForString(rhs, rhs === "");
                break;
            case "number_g":
                criteria += " > " + formatForString(rhs, rhs === "");
                break;
            case "number_l":
                criteria += " < " + formatForString(rhs, rhs === "");
                break;
            case "number_e":
                criteria += " = " + formatForString(rhs, rhs === "");
                break;
            case "number_between":
                if (numberFrom && numberTo) {
                    criteria = "( " + criteria + " >= " + numberFrom + " AND " + criteria + " <= " + numberTo + " )";
                } else if (numberFrom) {
                    criteria = "( " + criteria + " >= " + numberFrom + " )";
                } else if (numberTo) {
                    criteria = "( " + criteria + " <= " + numberTo + " )";
                } else {
                    criteria = "";
                }
                break;
            case "date_ge":
                criteria = "DATE(" + criteria + ") >= " + formatForDateString(rhs, (rhsOption < 1));
                break;
            case "date_le":
                criteria = "DATE(" + criteria + ") <= " + formatForDateString(rhs, (rhsOption < 1));
                break;
            case "date_g":
                criteria = "DATE(" + criteria + ") > " + formatForDateString(rhs, (rhsOption < 1));
                break;
            case "date_l":
                criteria += " < " + formatForDateString(rhs, (rhsOption < 1));
                criteria = "( " + criteria + " AND DATE(" + lhs + ") > '0000-00-00' )";
                break;
            case "date_e":
                criteria = "DATE(" + criteria + ") = " + formatForDateString(rhs, (rhsOption < 1));
                break;
            case "date_ne":
                criteria = "DATE(" + criteria + ") <> " + formatForDateString(rhs, (rhsOption < 1));
                break;
            case "date_l_s_d":
                criteria = "(DATE(" + criteria + ") >= DATE_SUB(CURDATE(), INTERVAL 7 DAY) AND DATE(" + criteria + ") <= CURDATE())";
                break;
            case "date_today":
                criteria = "DATE(" + criteria + ") = CURDATE()";
                break;
            case "date_tomorrow":
                criteria = "DATE(" + criteria + ") = DATE_ADD(CURDATE(), INTERVAL 1 DAY)";
                break;
            case "date_yesterday":
                criteria = "DATE(" + criteria + ") = DATE_SUB(CURDATE() , INTERVAL 1 DAY)";
                break;
            case "date_this_month":
                criteria = "(MONTH(" + criteria + ") = MONTH(CURDATE()) AND YEAR(" + criteria + ") = YEAR(CURDATE()))";
                break;
            case "date_this_year":
                criteria = "YEAR(" + criteria + ") = YEAR(CURDATE())";
                break;
            case "date_this_quarter":
                criteria = "(QUARTER(" + criteria + ") = QUARTER(CURDATE()) AND YEAR(" + criteria + ") = YEAR(CURDATE()))";
                break;
            case "date_this_past":
                criteria = "( " + criteria + " < NOW() AND DATE(" + criteria + ") > '0000-00-00' )";
                break;
            case "date_this_future":
                criteria = "( " + criteria + " > NOW() )";
                break;
            case "date_this_range":
                if (startDate || endDate) {
                    let startDateQuery, endDateQuery, query;
                    let month, endMonth;
                    if (startDate) {
                        month = startDate.getMonth() + 1;
                        startDateQuery = 'DATE(' + criteria + ') >= ' + "'" + startDate.getFullYear() + '-' + month + '-' + startDate.getDate() + "'";
                    }
                    if (endDate) {
                        endMonth = endDate.getMonth() + 1;
                        endDateQuery = 'DATE(' + criteria + ') <= ' + "'" + endDate.getFullYear() + '-' + endMonth + '-' + endDate.getDate() + "' AND DATE(" + criteria + ") > '0000-00-00'";
                    }
                    if (startDateQuery && endDateQuery) {
                        query = '(' + startDateQuery + ' AND ' + endDateQuery + ')';
                    } else if (startDateQuery) {
                        query = '(' + startDateQuery + ')';
                    } else if (endDateQuery) {
                        query = '(' + endDateQuery + ')';
                    }
                    criteria = query;
                } else {
                    criteria = "";
                }
                break;
            default:
        }

        return criteria;
    }

    checkForFunctionCriteria = function (criteriaRow, criteriaTree, generatedCriteriaRows) {
        var lsd_reg = /\( DATE\([A-za-z0-9.\s]*\) >= DATE_SUB\( CURDATE\(\) , INTERVAL 7 DAY \) AND DATE\([A-za-z0-9.\s]*\) <= CURDATE\(\) \)/g,
            number_from_reg = /[A-za-z0-9.\s]* >= [+-]?([0-9]*[.])?[0-9]+/,
            number_to_reg = /[A-za-z0-9.\s]* <= [+-]?([0-9]*[.])?[0-9]+/,
            date_range_reg_start = /DATE\([A-za-z0-9.\s]*\) >= \'\d{4}-\d{1,2}-\d{1,2}\'/,
            date_range_reg_end = /DATE\([A-za-z0-9.\s]*\) <= \'\d{4}-\d{1,2}-\d{1,2}\' AND DATE\([A-za-z0-9.\s]*\) > '0000-00-00'/,
            in_the_past_reg = /\( [A-za-z0-9.\s]* < NOW\(\) AND DATE\( [A-za-z0-9.\s]* \) > '0000-00-00' \)/g,
            date_l = /\( [A-za-z0-9.\s]* < \'\d{4}-\d{1,2}-\d{1,2}\' AND DATE\( [A-za-z0-9.\s]* \) > '0000-00-00' \)/g,
            // date_l_colRef = /\( [A-za-z0-9.\s]* < [A-za-z0-9.\s]* AND DATE\( [A-za-z0-9.\s]* \) > '0000-00-00' \)/g,
            in_the_future_reg = /\( [A-za-z0-9.\s]* > NOW\(\) \)/g,
            month_reg = /\( MONTH\([A-Za-z0-9.\s]*\) = MONTH\( CURDATE\(\) \) AND YEAR\([A-Za-z0-9.\s]*\) = YEAR\( CURDATE\(\) \) \)/g,
            quarter_reg = /\( QUARTER\([A-Za-z0-9.\s]*\) = QUARTER\( CURDATE\(\) \) AND YEAR\([A-Za-z0-9.\s]*\) = YEAR\( CURDATE\(\) \) \)/g,
            tempFuncCriteriaRow = [];
        // if(date_l_colRef.test(criteriaTree["base_expr"])) {
        //     criteriaRow.push(criteriaTree["sub_tree"][0])
        //     tempFuncCriteriaRow["base_expr"] = "<";
        //     tempFuncCriteriaRow["expr_type"] = "operator";
        //     tempFuncCriteriaRow["sub_tree"] = false;
        //     let temp = []
        //     temp["base_expr"] = criteriaTree["sub_tree"][2]["base_expr"];
        //     temp["expr_type"] = "colref";
        //     temp["no_quotes"] = criteriaTree["sub_tree"][2]["base_expr"];
        //     temp["position"] = criteriaTree.position
        //     temp["sub_tree"] = false;
        //     criteriaRow.push(tempFuncCriteriaRow);
        //     criteriaRow.push(temp);
        //     generatedCriteriaRows.push(criteriaRow);
        //     return true;
        // }
        if(date_l.test(criteriaTree["base_expr"])){
            criteriaRow.push(criteriaTree["sub_tree"][0])
            tempFuncCriteriaRow["base_expr"] = "<";
            tempFuncCriteriaRow["expr_type"] = "operator";
            tempFuncCriteriaRow["sub_tree"] = false;
            let temp = []
            temp["base_expr"] = criteriaTree["sub_tree"][2]["base_expr"];
            temp["expr_type"] = "const";
            temp["sub_tree"] = false;
            criteriaRow.push(tempFuncCriteriaRow);
            criteriaRow.push(temp);
            generatedCriteriaRows.push(criteriaRow);
            return true;
        }
        else if (lsd_reg.test(criteriaTree['base_expr'])) {
            criteriaRow.push(criteriaTree["sub_tree"][0]["sub_tree"][0]);
            tempFuncCriteriaRow["base_expr"] = 'last seven days';
            tempFuncCriteriaRow["expr_type"] = "function";
            tempFuncCriteriaRow["subtree"] = false;
            criteriaRow.push(tempFuncCriteriaRow);
            generatedCriteriaRows.push(criteriaRow);
            return true;

        } else if (month_reg.test(criteriaTree['base_expr'])) {
            criteriaRow.push(criteriaTree["sub_tree"][0]["sub_tree"][0]);
            tempFuncCriteriaRow["base_expr"] = 'this month';
            tempFuncCriteriaRow["expr_type"] = "function";
            tempFuncCriteriaRow["subtree"] = false;
            criteriaRow.push(tempFuncCriteriaRow);
            generatedCriteriaRows.push(criteriaRow);
            return true;

        } else if (quarter_reg.test(criteriaTree['base_expr'])) {
            criteriaRow.push(criteriaTree["sub_tree"][0]["sub_tree"][0]);
            tempFuncCriteriaRow["base_expr"] = 'this quarter';
            tempFuncCriteriaRow["expr_type"] = "function";
            tempFuncCriteriaRow["subtree"] = false;
            criteriaRow.push(tempFuncCriteriaRow);
            generatedCriteriaRows.push(criteriaRow);
            return true;

        } else if (date_range_reg_start.test(criteriaTree['base_expr']) || date_range_reg_end.test(criteriaTree['base_expr'])) {
            criteriaRow.push(criteriaTree["sub_tree"][0]["sub_tree"][0]);
            tempFuncCriteriaRow["base_expr"] = 'date range';
            tempFuncCriteriaRow["expr_type"] = "function";
            if (date_range_reg_start.test(criteriaTree['base_expr']) && date_range_reg_end.test(criteriaTree['base_expr'])) {
                tempFuncCriteriaRow["startDate"] = criteriaTree["sub_tree"][2]["base_expr"].replace(/'/g, "");
                tempFuncCriteriaRow["endDate"] = criteriaTree["sub_tree"][6]["base_expr"].replace(/'/g, "");
            } else if (date_range_reg_start.test(criteriaTree['base_expr'])) {
                tempFuncCriteriaRow["startDate"] = criteriaTree["sub_tree"][2]["base_expr"].replace(/'/g, "");
                tempFuncCriteriaRow["endDate"] = "";
            } else if (date_range_reg_end.test(criteriaTree['base_expr'])) {
                tempFuncCriteriaRow["startDate"] = "";
                tempFuncCriteriaRow["endDate"] = criteriaTree["sub_tree"][2]["base_expr"].replace(/'/g, "");
            }
            tempFuncCriteriaRow["subtree"] = false;
            criteriaRow.push(tempFuncCriteriaRow);
            generatedCriteriaRows.push(criteriaRow);
            return true;
        } else if (in_the_past_reg.test(criteriaTree['base_expr'])) {
            criteriaRow.push(criteriaTree["sub_tree"][0]);
            tempFuncCriteriaRow["base_expr"] = 'in the past';
            tempFuncCriteriaRow["expr_type"] = "function";
            tempFuncCriteriaRow["subtree"] = false;
            criteriaRow.push(tempFuncCriteriaRow);
            generatedCriteriaRows.push(criteriaRow);
            return true;
        } else if (in_the_future_reg.test(criteriaTree['base_expr'])) {
            criteriaRow.push(criteriaTree["sub_tree"][0]);
            tempFuncCriteriaRow["base_expr"] = 'in the future';
            tempFuncCriteriaRow["expr_type"] = "function";
            tempFuncCriteriaRow["subtree"] = false;
            criteriaRow.push(tempFuncCriteriaRow);
            generatedCriteriaRows.push(criteriaRow);
            return true;
        } else if (number_from_reg.test(criteriaTree['base_expr']) || number_to_reg.test(criteriaTree['base_expr'])) {
            criteriaRow.push(criteriaTree["sub_tree"][0]);
            tempFuncCriteriaRow["base_expr"] = 'in between';
            tempFuncCriteriaRow["expr_type"] = "function";
            if (number_from_reg.test(criteriaTree['base_expr']) && number_to_reg.test(criteriaTree['base_expr'])) {
                tempFuncCriteriaRow["numberFrom"] = criteriaTree["sub_tree"][2]["base_expr"];
                tempFuncCriteriaRow["numberTo"] = criteriaTree["sub_tree"][6]["base_expr"];
            } else if (number_from_reg.test(criteriaTree['base_expr'])) {
                tempFuncCriteriaRow["numberFrom"] = criteriaTree["sub_tree"][2]["base_expr"];
                tempFuncCriteriaRow["numberTo"] = "";
            } else if (number_to_reg.test(criteriaTree['base_expr'])) {
                tempFuncCriteriaRow["numberFrom"] = "";
                tempFuncCriteriaRow["numberTo"] = criteriaTree["sub_tree"][2]["base_expr"];
            }
            tempFuncCriteriaRow["subtree"] = false;
            criteriaRow.push(tempFuncCriteriaRow);
            generatedCriteriaRows.push(criteriaRow);
            return true;
        } else {
            return false;
        }
    }

    generateCriteriaRows = function (criteriaTree, rows, generatedCriteriaRows = []) {
        var criteriaRow = (typeof rows == "undefined") ? [] : rows,
            expectedType = ["colref", "const", "in-list", "bracket_expression", "function", "operator"];

        for (var i = 0; i < criteriaTree.length; i++) {
            var exprType = criteriaTree[i]["expr_type"];
            switch (exprType) {
                case "bracket_expression":
                    if (criteriaRow.length == 0 && criteriaTree[i]["sub_tree"][0]["expr_type"] != "function") {
                        if (criteriaTree[i]["sub_tree"].length > 2 
                            && criteriaTree[i]["sub_tree"][0]["expr_type"] === "colref" 
                            && (criteriaTree[i]["sub_tree"][2]["base_expr"] === "NOW"
                                || (criteriaTree[i]["sub_tree"][2]["expr_type"] === "const"
                                    && (criteriaTree[i]["sub_tree"][1]["base_expr"] === "<"
                                        || criteriaTree[i]["sub_tree"][1]["base_expr"] === ">"
                                        || criteriaTree[i]["sub_tree"][1]["base_expr"] === ">="
                                        || criteriaTree[i]["sub_tree"][1]["base_expr"] === "<="
                                        )))
                        ) {
                            if (this.checkForFunctionCriteria(criteriaRow, criteriaTree[i], generatedCriteriaRows)) {
                                criteriaRow = [];
                            } else {
                                return false;
                            }
                        }
                         else {
                            var generatedCriteriaRowsLength = generatedCriteriaRows.length;

                            if (this.generateCriteriaRows(criteriaTree[i]["sub_tree"], [], generatedCriteriaRows)) {
                                var newGeneratedCriteriaRowsLength = generatedCriteriaRows.length;

                                if ((newGeneratedCriteriaRowsLength - generatedCriteriaRowsLength > 1)
                                    && criteriaTree.length !== 1) {
                                    return false;
                                }

                                expectedType = ["operator"];
                            } else {
                                return false;
                            }
                        }
                    } else if (criteriaRow.length == 0 && criteriaTree[i]["sub_tree"][0]["expr_type"] == "function") {
                        expectedType = ["operator"];
                        if (this.checkForFunctionCriteria(criteriaRow, criteriaTree[i], generatedCriteriaRows)) {
                            criteriaRow = [];
                        } else {
                            return false;
                        }
                    } else if (criteriaRow.length != 0) {
                        expectedType = ["operator"];
                        if (this.checkForFunctionCriteria(criteriaRow, criteriaTree[i], generatedCriteriaRows)) {
                            criteriaRow = [];
                        } else {
                            return false;
                        }
                    } else {
                        console.log("Report an error 1");
                        return false;
                    }
                    break;

                case "colref":
                case "const":
                    if (expectedType.indexOf(exprType) > -1) {
                        criteriaRow.push(criteriaTree[i]);
                        if ((typeof criteriaTree[i + 1] == "undefined") || (criteriaTree[i + 1] && ["and", "or"].indexOf(criteriaTree[i + 1]['base_expr'].toLowerCase()) > -1)) {
                            /*if (criteriaTree[i + 1] && criteriaTree[i + 1]['base_expr'].toLowerCase() == "or") {
                             return false;
                             }*/
                            generatedCriteriaRows.push(criteriaRow)
                            expectedType = ["operator"];
                            criteriaRow = [];
                        } else {
                            expectedType = ["operator"]
                        }
                    } else {
                        console.log("Report an error 2");
                        return false;
                    }
                    break;

                case "in-list":
                    if (expectedType.indexOf(exprType) > -1) {
                        criteriaRow.push(criteriaTree[i]);
                        expectedType = ["operator"]
                        generatedCriteriaRows.push(criteriaRow)
                        criteriaRow = [];
                    } else {
                        console.log("Report an error 3");
                        return false;
                    }
                    break;

                case "operator":
                    if (expectedType.indexOf(exprType) > -1) {
                        //if (criteriaRow.length == 0) {
                        //    expectedType = ["colref", "const", "in-list", "bracket_expression"];
                        //} else {
                        var lastExpr = criteriaRow[criteriaRow.length - 1];
                        if (lastExpr && lastExpr["expr_type"] == "operator") {
                            lastExpr["base_expr"] = lastExpr["base_expr"] + " " + criteriaTree[i]["base_expr"]
                        } else {
                            criteriaRow.push(criteriaTree[i]);
                            // if (criteriaRow.length === 1) {
                            //     generatedCriteriaRows.push(criteriaRow)
                            //     criteriaRow = [];
                            // }
                        }

                        expectedType = ["operator", "colref", "const", "in-list", "bracket_expression", "function"];
                        if (lastExpr && (lastExpr["base_expr"] === "not in" || lastExpr["base_expr"] === "in")) {
                            expectedType = ["in-list"];
                        }
                        // }
                    } else {
                        console.log("Report an error 4");
                        return false;
                    }
                    break;

                case "function":
                    if (expectedType.indexOf(exprType) > -1) {
                        return this.generateCriteriaFunctionRows(criteriaTree.splice(i, criteriaTree.length), criteriaRow, generatedCriteriaRows);
                    } else {
                        console.log("Report an error 4");
                        return false;
                    }
                    break;

                default:
                    return false;
            }
        }

        return generatedCriteriaRows;
    }

    generateCriteriaFunctionRows = function (criteriaTree, criteriaRow, generatedCriteriaRows) {
        var expectedType = ["function"], tempFuncCriteriaRow = [];

        for (var i = 0; i < criteriaTree.length; i++) {
            var exprType = criteriaTree[i]["expr_type"];
            switch (exprType) {
                case "operator":
                    if (expectedType.indexOf(exprType) > -1) {
                        var lastExpr = criteriaRow[criteriaRow.length - 1];
                        if (lastExpr && lastExpr["expr_type"] == "operator") {
                            lastExpr["base_expr"] = lastExpr["base_expr"] + " " + criteriaTree[i]["base_expr"]
                        } else {
                            if (["and", "or"].indexOf(criteriaTree[i]['base_expr'].toLowerCase()) > -1) {
                                return this.generateCriteriaRows(criteriaTree.splice(i, criteriaTree.length), [], generatedCriteriaRows);
                            }
                        }
                        expectedType = ["operator", "function"];
                    } else {
                        console.log("Report an error 4");
                        return false;
                    }
                    break;

                case "function":
                    if (expectedType.indexOf(exprType) > -1) {
                        if (criteriaTree[i]["base_expr"] == "DATE" || criteriaTree[i]["base_expr"] == "CURDATE") {
                            if (criteriaTree[i]["sub_tree"].length == 1 && criteriaTree[i]["sub_tree"][0]["expr_type"] == "colref") {
                                criteriaRow.push(criteriaTree[i]["sub_tree"][0]);
                                expectedType = ["operator"];
                            } else {
                                if (criteriaTree[i]["base_expr"] == "CURDATE" && (typeof criteriaTree[i + 1] == "undefined") || (criteriaTree[i + 1] && ["and", "or"].indexOf(criteriaTree[i + 1]['base_expr'].toLowerCase()) > -1)) {
                                    tempFuncCriteriaRow = [];
                                    tempFuncCriteriaRow["base_expr"] = "today";
                                    tempFuncCriteriaRow["expr_type"] = "function";
                                    tempFuncCriteriaRow["subtree"] = false;
                                    criteriaRow.push(tempFuncCriteriaRow);
                                    generatedCriteriaRows.push(criteriaRow)
                                    expectedType = ["operator"];
                                    criteriaRow = [];
                                } else {
                                    expectedType = ["operator"];
                                }
                            }
                        } else if (criteriaTree[i]["base_expr"] == "YEAR") {
                            if (criteriaTree[i]["sub_tree"][0]["expr_type"] == "colref") {
                                criteriaRow.push(criteriaTree[i]["sub_tree"][0]);
                                expectedType = ["operator"];
                            } else if (criteriaTree[i]["sub_tree"][0]["expr_type"] == "function" && (typeof criteriaTree[i + 1] == "undefined") || (criteriaTree[i + 1] && ["and", "or"].indexOf(criteriaTree[i + 1]['base_expr'].toLowerCase()) > -1)) {
                                tempFuncCriteriaRow = [];
                                tempFuncCriteriaRow["base_expr"] = "this year";
                                tempFuncCriteriaRow["expr_type"] = "function";
                                tempFuncCriteriaRow["subtree"] = false;
                                criteriaRow.push(tempFuncCriteriaRow);
                                generatedCriteriaRows.push(criteriaRow)
                                expectedType = ["operator"];
                                criteriaRow = [];
                            } else {
                                return false;
                            }
                        } else if (criteriaTree[i]["base_expr"] == "DATE_SUB" && criteriaTree[i]["sub_tree"] && criteriaTree[i]["sub_tree"][0]["base_expr"] == "CURDATE" && criteriaTree[i]["sub_tree"][1]["base_expr"] == " INTERVAL 1 DAY") {
                            tempFuncCriteriaRow = [];
                            tempFuncCriteriaRow["base_expr"] = "yesterday";
                            tempFuncCriteriaRow["expr_type"] = "function";
                            tempFuncCriteriaRow["subtree"] = false;
                            criteriaRow.push(tempFuncCriteriaRow);
                            generatedCriteriaRows.push(criteriaRow);
                            expectedType = ["operator"];
                            criteriaRow = [];

                        } else if (criteriaTree[i]["base_expr"] == "DATE_ADD" && criteriaTree[i]["sub_tree"] && criteriaTree[i]["sub_tree"][0]["base_expr"] == "CURDATE" && criteriaTree[i]["sub_tree"][1]["base_expr"] == " INTERVAL 1 DAY") {
                            tempFuncCriteriaRow = [];
                            tempFuncCriteriaRow["base_expr"] = "tomorrow";
                            tempFuncCriteriaRow["expr_type"] = "function";
                            tempFuncCriteriaRow["subtree"] = false;
                            criteriaRow.push(tempFuncCriteriaRow);
                            generatedCriteriaRows.push(criteriaRow);
                            expectedType = ["operator"];
                            criteriaRow = [];
                        } else {
                            return false;
                        }
                    } else {
                        console.log("Report an error 4");
                        return false;
                    }
                    break;
                case "const":
                    if (criteriaTree[i - 2]["expr_type"] == "function" &&
                        criteriaTree[i - 2]["base_expr"].toLowerCase() == "date" &&
                        (criteriaTree[i - 1]["base_expr"] == "=" ||
                            criteriaTree[i - 1]["base_expr"] == "<>" ||
                            criteriaTree[i - 1]["base_expr"] == "<=" ||
                            criteriaTree[i - 1]["base_expr"] == ">=" ||
                            criteriaTree[i - 1]["base_expr"] == ">" ) &&
                        criteriaTree[i-1]["expr_type"] == "operator") {
                        tempFuncCriteriaRow = []
                        tempFuncCriteriaRow["base_expr"] = criteriaTree[i - 1]["base_expr"];
                        tempFuncCriteriaRow["expr_type"] = "operator";
                        tempFuncCriteriaRow["subtree"] = false;
                        criteriaRow.push(tempFuncCriteriaRow);
                        tempFuncCriteriaRow = []
                        tempFuncCriteriaRow["base_expr"] = criteriaTree[i]["base_expr"];
                        tempFuncCriteriaRow["expr_type"] = "const";
                        tempFuncCriteriaRow["subtree"] = false;
                        criteriaRow.push(tempFuncCriteriaRow);
                        generatedCriteriaRows.push(criteriaRow);
                        expectedType = ["operator"];
                        criteriaRow = [];
                    } else {
                        return false
                    }
                    break
                default:
                    return false;
            }
        }

        return generatedCriteriaRows;
    }

    /////criteria row
    getOperator(expr = "", rhsFullValue = "", lhsValue = "") {
        var relationValue = '',
            operators = {
                'text': {
                    'like': 'string_like',
                    'not like': 'string_not_like',
                    'is': 'string_empty',
                    'is not': 'string_not_empty',
                    '=': 'string_equal',
                    '<>': 'string_not_equal',
                    'in': 'string_equal',
                    'not in': 'string_not_equal'
                },
                'number': {
                    '=': 'number_e',
                    '<=': 'number_le',
                    '>=': 'number_ge',
                    '<>': 'number_ne',
                    '<': 'number_l',
                    '>': 'number_g',
                    'in between': 'number_between'
                },
                date: {
                    '=': 'date_e',
                    '<>': 'date_ne',
                    '<=': 'date_le',
                    '>=': 'date_ge',
                    '<': 'date_l',
                    '>': 'date_g',
                    'today': 'date_today',
                    'tomorrow': 'date_tomorrow',
                    'yesterday': 'date_yesterday',
                    'last seven days': 'date_l_s_d',
                    'this month': 'date_this_month',
                    'this year': 'date_this_year',
                    'this quarter': 'date_this_quarter',
                    'in the past': 'date_this_past',
                    'in the future': 'date_this_future',
                    'date range': 'date_this_range',
                }
            },
            operatorTypes = {
                'number': ["number_le", "number_ge", "number_ne", "number_l", "number_g", "number_between"],
                'date': ["date_le", "date_ge", "date_l", "date_g", "date_ne", "date_today", "date_tomorrow", "date_yesterday", "date_l_s_d", "date_this_month", "date_this_year", "date_this_quarter", "date_this_past", "date_this_future", "date_this_range"],
                'text': ["string_equal", "string_not_equal", "string_like", "string_not_like", "string_right_like", "string_left_like", "string_empty", "string_not_empty"]
            },
            // relation = this.down("#relation"),
            operatorValue = Ext.String.trim(expr).toLowerCase(),
            operatorType = this.getOperatorType(lhsValue, null);

        if (!operators[operatorType] || typeof operators[operatorType][operatorValue] == "undefined") {
            // This case might come if lookup columns's source sheet columns are selected on LHS.
            // TODO: If we can get proper operator type based on LHS column type, this case is not required and it works correctly.
            var isFound = false;
            for (var ot in operators) {
                if (operators.hasOwnProperty(ot)) {
                    for (var ov in operators[ot]) {
                        if (ov == operatorValue) {
                            operatorType = ot;
                            isFound = true;
                            break;
                        }
                    }
                }

                if (isFound) {
                    break;
                }
            }
        }
        relationValue = operators[operatorType][operatorValue];

        if (relationValue == 'string_like') {
            var leftLike, rightLike;
            leftLike = rhsFullValue.match("^[\\s']*%");
            rightLike = rhsFullValue.match("%[\\s']*$");
            if (leftLike && rightLike) {

            } else if (leftLike) {
                relationValue = "string_left_like";
            } else if (rightLike) {
                relationValue = "string_right_like";
            }
        } else if (relationValue == 'is') {
            if (Ext.String.trim(rhsFullValue).toLowerCase() == "empty") {
                relationValue = "string_empty"
            }
        }

        return { operator: relationValue, operatorType };

    }


    getOperatorType(value, rec) {
        var recIndex = -1,
            operatorType = "text";

        if (!rec || typeof rec === "string") {
            recIndex = this.leftColumns.findIndex((col) => col.alias_path === value);
            if (recIndex > -1) {
                rec = this.leftColumns[recIndex];
            } else if (String(value).split(".").length > 2) {
                if (window.hasOwnProperty("lookupColumnsInfo") && window.lookupColumnsInfo.hasOwnProperty(value)) {
                    rec = window.lookupColumnsInfo[value]
                } else {
                    return operatorType;
                }
            } else {
                return operatorType;
            }
        } else {
            rec = rec.data;
        }
        if ([7, 19].indexOf(parseInt(rec.column_type_id)) > -1 && (typeof rec.default_type == 'undefined' || rec.default_type == 0)) {
            var opts = Ext.decode(rec.options);

            if (typeof opts[0].formula_column == 'undefined') {
                return operatorType;
            }
            rec = opts[0].formula_column;
        }

        if ([4, 16].indexOf(parseInt(rec.column_type_id)) > -1 && (typeof rec.default_type == 'undefined' || rec.default_type == 0)) {
            operatorType = "date";
        } else if ([5, 22, 17].indexOf(parseInt(rec.column_type_id)) > -1 && (typeof rec.default_type == 'undefined' || rec.default_type == 0)) {
            operatorType = "number";
        } else if (rec.options) {
            var options = Ext.decode(rec.options);
            options = (options.length > 0) ? options[0] : {};
            if (options.column_type && options.column_type == "number") {
                operatorType = "number";
            }
        }

        return operatorType;
    }

    getInitialCriteriaFormatted(value) {
        let initialCriteria, initialCriteriaFormatted;
        let isLengthExceeded=false;
        if (value.query_string) {

            initialCriteria = this.getCriteria(
                value.query_string,
                cloneDeep(value.query_tree)
            );


            initialCriteriaFormatted = (initialCriteria || []).map((value) => {
                if((value.length > 3 && !["and", "or"].includes(value[0]?.base_expr.toLowerCase())) || (value.length > 4 && ["and", "or"].includes(value[0]?.base_expr.toLowerCase()))){
                    isLengthExceeded=true;
                    return [];
                }
                let condition;
                if (value[0]?.expr_type === "operator") {
                    condition = value[0].base_expr;
                    value = value.slice(1);
                }
                const lhsValue = value[0]["base_expr"];
                let rhsFullValue = "",
                    rhsValue = "";
                let rhsValueType, startDate, endDate, numberFrom, numberTo;
                if (value[1]["base_expr"] === "date range") {
                    startDate = value[1]["startDate"];
                    endDate = value[1]["endDate"];
                }
                if (value[1]["base_expr"] === "in between") {
                    numberFrom = value[1]["numberFrom"];
                    numberTo = value[1]["numberTo"];
                }
                if (value[2]) {
                    rhsValueType = 0;
                    for (var i = 2; i < value.length; i++) {
                        rhsFullValue += value[i]["base_expr"];
                        if (value[i]["expr_type"] === "colref") {
                            rhsValue = value[i]["base_expr"] + "";
                            rhsValueType =
                                rhsValue.search("LOGGED_IN_USER") == 0
                                    ? 2
                                    : rhsValue.search("ROLE") == 0
                                        ? 3
                                        : 1;
                        } else if (value[i]["expr_type"] === "in-list") {
                            rhsValue = value[i].sub_tree.map(({ base_expr }) => {
                                return base_expr.replace(/^'|'$/g, "");
                            })
                        }
                    }
                }
                if (!rhsValue) {
                    rhsValue = rhsFullValue;
                }
                let isPercentageColumn = false;
                this.leftColumns.forEach(el => {
                    if (el.alias_name == value[0]["base_expr"] || el.alias_path == value[0]["base_expr"]) {
                        if (el.column_type_id == '22') {
                            isPercentageColumn = true;
                        } else if (el.column_type_id == "10") {
                            let options = JSON.parse(el.options)
                            if (options && options[0].column_type == "percentage") {
                                isPercentageColumn = true
                            }
                        }
                    }
                })
                let isStarColumn = false;
                this.leftColumns.forEach(el => {
                    if (el.alias_name == value[0]["base_expr"] || el.alias_path == value[0]["base_expr"]) {
                        if (el.column_type_id == '1' && el.default_type == '1') {
                            let options = JSON.parse(el.options)
                            if (options && options[0].is_star_column == true) {
                                isStarColumn = true;
                            }
                        }
                    }
                })
                let percentageAliases = window.hasOwnProperty("percentageAliases") ? window.percentageAliases : []
                if (percentageAliases.includes(value[0]["base_expr"])) {
                    isPercentageColumn = true
                }
                if (isPercentageColumn && rhsValue) {
                    rhsValue = String(rhsValue).replace("'", "").replace("'", "")
                    let decimals = rhsValue.includes('.') ? rhsValue.split('.')[1].length : 0;
                    rhsValue = String((Number(rhsValue) * 100).toFixed(decimals >= 2 ? decimals - 2 : 0));
                }
                var { operatorType, operator } = this.getOperator(
                    value[1]["base_expr"],
                    rhsFullValue,
                    lhsValue
                );
                if (isStarColumn) {
                    if (value[1]["base_expr"] == "IS NOT" && value[2]["base_expr"] == "EMPTY") {
                        operator = "string_equal";
                        rhsValue = "is starred";
                        rhsValueType = 0;
                    } else if (value[1]["base_expr"] == "IS" && value[2]["base_expr"] == "EMPTY") {
                        operator = "string_not_equal";
                        rhsValue = "is starred";
                        rhsValueType = 0;
                    }
                }
                if(operator == "number_between" && isPercentageColumn){
                    if(numberFrom){
                        let decimals = String(numberFrom).includes(".") ? String(numberFrom).split(".")[1].length : 0
                        numberFrom = String((Number(numberFrom)*100).toFixed(decimals >= 2 ? decimals - 2 : 0))
                    }
                    if(numberTo){
                        let decimals = String(numberTo).includes(".") ? String(numberTo).split(".")[1].length : 0
                        numberTo = String((Number(numberTo)*100).toFixed(decimals >= 2 ? decimals - 2 : 0))
                    }
                }

                if (rhsValueType == 1 || rhsValueType == 2 || rhsValueType == 3) {
                } else if (typeof rhsValue === "string") {
                    rhsValue = rhsValue.replace(/^'|'$/g, ""); //removes trialing quotes
                    rhsValue = rhsValue.replace(/^%|%$/g, ""); //removes trialing %'s
                }

                if (rhsValueType === 0 && (operator === "string_not_equal" || operator === "string_equal") && !Array.isArray(rhsValue)) {
                    rhsValue = [rhsValue]
                }

                return {
                    lhs: lhsValue,
                    operatorType,
                    operator: operator,
                    rhsType: rhsValueType,
                    rhs: rhsValue,
                    startDate: startDate && startDate !== "" ? new Date(startDate) : startDate,
                    endDate: endDate && endDate !== "" ? new Date(endDate) : endDate,
                    numberFrom: numberFrom,
                    numberTo: numberTo,
                    key: Math.random(),
                    condition
                };
            });
        }

        if(isLengthExceeded){
            return [];
        }
        return initialCriteriaFormatted;
    }

    getOperators(operatorType, lhs) {
        let isStarColumn = false;
        this.leftColumns.forEach(el => {
            if (el.alias_name == lhs) {
                if (el.column_type_id == '1' && el.default_type == '1') {
                    let options = JSON.parse(el.options)
                    if (options && options[0].is_star_column == true) {
                        isStarColumn = true;
                    }
                }
            }
        })
        var operators = [];
        if (operatorType === "date") {
            // default columns will be shown as string type always
            operators = [
                { symbol: "=", operator: "date_e" },
                { symbol: "<>", operator: "date_ne" },
                { symbol: "<=", operator: "date_le" },
                { symbol: ">=", operator: "date_ge" },
                { symbol: ">", operator: "date_g" },
                { symbol: "<", operator: "date_l" },
                { symbol: "today", operator: "date_today" },
                { symbol: "tomorrow", operator: "date_tomorrow" },
                { symbol: "yesterday", operator: "date_yesterday" },
                { symbol: "last seven days", operator: "date_l_s_d" },
                { symbol: "this month", operator: "date_this_month" },
                { symbol: "this year", operator: "date_this_year" },
                { symbol: "this quarter", operator: "date_this_quarter" },
                { symbol: "in the past", operator: "date_this_past" },
                { symbol: "in the future", operator: "date_this_future" },
                { symbol: "date range", operator: "date_this_range" }
            ];
        } else if (operatorType === "number") {
            // default columns will be shown as string type always
            operators = [
                { symbol: "=", operator: "number_e" },
                { symbol: "<=", operator: "number_le" },
                { symbol: ">=", operator: "number_ge" },
                { symbol: "<>", operator: "number_ne" },
                { symbol: "<", operator: "number_l" },
                { symbol: ">", operator: "number_g" },
                { symbol: "in between", operator: "number_between" },
            ];
        } else {
            if (isStarColumn) {
                operators = [
                    { symbol: "equal to", operator: "string_equal" },
                    { symbol: "not equal to", operator: "string_not_equal" },
                    { symbol: "contains", operator: "string_like" },
                    { symbol: "does not contain", operator: "string_not_like" },
                    { symbol: "is empty", operator: "string_empty" },
                    { symbol: "is not empty", operator: "string_not_empty" },
                ];
            }
            else {
                //if [1, 2, 3, 7, 8, 9, 10, 11, 12, 13]
                operators = [
                    { symbol: "equal to", operator: "string_equal" },
                    { symbol: "not equal to", operator: "string_not_equal" },
                    { symbol: "contains", operator: "string_like" },
                    { symbol: "does not contain", operator: "string_not_like" },
                    { symbol: "starts with", operator: "string_right_like" },
                    { symbol: "ends with", operator: "string_left_like" },
                    { symbol: "is empty", operator: "string_empty" },
                    { symbol: "is not empty", operator: "string_not_empty" },
                ];
            }
        }
        return operators;
    }

    getRhsValueOptions(isColumnTypeDisabled = true, hasRoleValueType = false, onlyValueType = false) {
        const rhsValueOptions = [
            { value: 0, name: "Value", qtip: "Assign some static value" },
        ];

        if (onlyValueType) {
            return rhsValueOptions;
        }

        if (!isColumnTypeDisabled) {
            rhsValueOptions.push({
                value: 1,
                name: "Column",
                qtip: "Select a column from this sheet",
            });
        }

        rhsValueOptions.push({
            value: 2,
            name: "Logged-in-User Column",
            qtip: "Select a column from logged in user",
        });

        if (hasRoleValueType) {
            rhsValueOptions.push({
                value: 3,
                name: "Role",
                qtip: "Select a role from this sheet",
            });
        }
        return rhsValueOptions;
    }

}